export default [
  {
    path: '/editorials',
    name: 'editorials',
    component: () => import('../../views/editorials/editorials.vue'),
    meta: {
      pageTitle: 'Videos',
      breadcrumbs: ['Videos', 'Editorials'],
    },
    children:[
      {
        path: '',
        name: 'editorials-list',
        component: () => import('../../views/editorials/list.vue')
      },
      {
        path: 'create',
        name: 'editorials-create',
        component: () => import('../../views/editorials/create.vue'),
        meta: {
          pageTitle: 'Create Editorial',
          breadcrumbs: ['Editorials', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'editorials-edit',
        component: () => import('../../views/editorials/edit.vue'),
        meta: {
          pageTitle: 'Edit Editorials',
          breadcrumbs: ['Editorials', 'Edit'],
        }
      }
    ]
  }
]
